import clientNotificationCenterReducer from "./clientNotificationCenterSlice";

export default clientNotificationCenterReducer;
